"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_hook_form_1 = require("react-hook-form");
var utils_1 = require("@/utils");
var Styled = __importStar(require("./ContentTemplate.styled"));
var components_1 = require("@/components");
var time_16_svg_1 = __importDefault(require("@/assets/svg/time-16.svg"));
var trash_can_36_svg_1 = __importDefault(require("@/assets/svg/trash-can-36.svg"));
var ContentTemplate = function (_a) {
    var _b;
    var name = _a.name, index = _a.index, onRemove = _a.onRemove, errors = _a.errors;
    var register = (0, react_hook_form_1.useFormContext)().register;
    var handleRemoveContent = function () { return onRemove(index); };
    return ((0, jsx_runtime_1.jsxs)(Styled.ContentTemplateContainer, { children: [(0, jsx_runtime_1.jsxs)(Styled.ContentTemplateWrapper, { children: [(0, jsx_runtime_1.jsxs)(Styled.ContentTemplateTitleWrapper, { children: [(0, jsx_runtime_1.jsxs)(Styled.ContentTemplateIndex, { children: [(0, utils_1.getReadableIndex)(index), "."] }, void 0), (0, jsx_runtime_1.jsx)(components_1.InputField, __assign({ "$size": "md", placeholder: "\uCF58\uD150\uCE20 \uC81C\uBAA9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694" }, register("".concat(name, ".").concat(index, ".title"), { required: true })), void 0)] }, void 0), (0, jsx_runtime_1.jsx)(components_1.InputField, __assign({ "$size": "sm", placeholder: "\uC124\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694(\uC120\uD0DD\uC0AC\uD56D\uC785\uB2C8\uB2E4.)" }, register("".concat(name, ".").concat(index, ".desc"))), void 0), (0, jsx_runtime_1.jsx)(Styled.StartedAtInputField, __assign({ "$size": "md", placeholder: "13:00", endIcon: (0, jsx_runtime_1.jsx)(time_16_svg_1.default, {}, void 0), errorMessage: (_b = errors === null || errors === void 0 ? void 0 : errors.startedAt) === null || _b === void 0 ? void 0 : _b.message }, register("".concat(name, ".").concat(index, ".startedAt"), {
                        required: true,
                        pattern: {
                            value: utils_1.TIME_REGEX,
                            message: '시간 형식이 아닙니다.',
                        },
                    })), void 0)] }, void 0), (0, jsx_runtime_1.jsx)(Styled.RemoveIcon, __assign({ type: "button", onClick: handleRemoveContent }, { children: (0, jsx_runtime_1.jsx)(trash_can_36_svg_1.default, {}, void 0) }), void 0)] }, void 0));
};
exports.default = ContentTemplate;
